import React from 'react';
import type { CFScene } from '@types';
import { Collapse } from '@components/Collapse';
import { Validator } from '@components/Validator';
import { useCustomFeature } from '../CustomFeatureContext';
import SceneSelector from '../components/SceneSelector';

function CSceneSetting() {
  const { data, setData } = useCustomFeature<CFScene>();
  return (
    <Collapse title="场景切换设置">
      <Validator
        value={data.sceneId}
        validFn={(value) => !!value}
        warningMessage="请选择目标场景"
      >
        {({ value, warning }) => (
          <SceneSelector
            sceneId={value}
            warning={warning}
            onChange={(id) =>
              setData((draft) => {
                draft.sceneId = id || 0;
              })
            }
          />
        )}
      </Validator>
    </Collapse>
  );
}

export default CSceneSetting;
